import { useMemo, useState } from 'react';
import type { EventStatus, PersonRef } from '../../shared/api/types';

export const STATUS_LABEL: Record<EventStatus, string> = {
  pending: 'Por aprobar',
  approved: 'Aprobado',
  rejected: 'No aprobado',
  canceled: 'Cancelado',
};

export function StatusBadge({ status }: { status: EventStatus }) {
  const tone = status === 'approved' ? 'badge--active' : status === 'pending' ? 'badge--warn' : '';
  return <span className={`badge ${tone}`}>{STATUS_LABEL[status]}</span>;
}

/** «sábado 12 de octubre · 19:00 – 21:00» */
export function formatWhen(startsAt: string, endsAt: string): string {
  const s = new Date(startsAt);
  const e = new Date(endsAt);
  const day = s.toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long' });
  const time = (d: Date) => d.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' });
  const sameDay = s.toDateString() === e.toDateString();
  const end = sameDay ? time(e) : `${e.toLocaleDateString('es', { day: 'numeric', month: 'short' })} ${time(e)}`;
  return `${day.charAt(0).toUpperCase()}${day.slice(1)} · ${time(s)} – ${end}`;
}

/** Selector de varias personas con búsqueda. */
export function PeoplePicker({
  people,
  value,
  onChange,
  label,
  idPrefix,
}: {
  people: PersonRef[];
  value: string[];
  onChange: (ids: string[]) => void;
  label: string;
  idPrefix: string;
}) {
  const [query, setQuery] = useState('');
  const shown = useMemo(() => {
    const q = query.trim().toLocaleLowerCase('es');
    return q ? people.filter((p) => p.name.toLocaleLowerCase('es').includes(q)) : people;
  }, [people, query]);
  const selected = new Set(value);
  const toggle = (id: string) => onChange(selected.has(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <fieldset className="picker">
      <legend>
        {label} {value.length > 0 ? <span className="muted small">({value.length} elegidos)</span> : null}
      </legend>
      <input type="search" placeholder="Buscar persona…" aria-label={`Buscar en ${label}`} value={query} onChange={(e) => setQuery(e.target.value)} />
      <ul className="picker__list">
        {shown.map((p) => (
          <li key={p.personId}>
            <label htmlFor={`${idPrefix}-${p.personId}`} className="check">
              <input id={`${idPrefix}-${p.personId}`} type="checkbox" checked={selected.has(p.personId)} onChange={() => toggle(p.personId)} />
              {p.name}
            </label>
          </li>
        ))}
        {shown.length === 0 ? <li className="muted small">Sin resultados.</li> : null}
      </ul>
    </fieldset>
  );
}

export const publicEventUrl = (token: string) => `${window.location.origin}/e/${token}`;
